import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { registryApi, routerApi } from './services/registry';
import { billingApi } from './services/billing';
import {
  labAssistantBillingReducer,
  labAssistantBillingSliceName,
} from './slices/lab-assistant-billing.slice';
import { labAssistantBillingMiddleware } from './slices/lab-assistant-billing.middleware';

export const store = configureStore({
  reducer: {
    [registryApi.reducerPath]: registryApi.reducer,
    [routerApi.reducerPath]: routerApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [labAssistantBillingSliceName]: labAssistantBillingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      // The listener middleware MUST come before the API
      // middlewares so it sees fulfilled/rejected actions before
      // RTK Query's internal cache-invalidation logic.
      .prepend(labAssistantBillingMiddleware.middleware)
      .concat([registryApi.middleware, routerApi.middleware, billingApi.middleware]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);

export default store;
